import React, { useEffect, useRef, useState } from 'react';
interface BeehiivEmbedProps {
  formId: string;
  className?: string;
}
const LOADER_SRC = 'https://subscribe-forms.beehiiv.com/v3/loader.js';
export function BeehiivEmbed({
  formId,
  className
}: BeehiivEmbedProps) {
  const containerRef = useRef<HTMLDivElement>(null);
  const [status, setStatus] = useState<'loading' | 'ready' | 'error'>('loading');
  useEffect(() => {
    const container = containerRef.current;
    if (!container) return;
    container.innerHTML = '';
    setStatus('loading');
    const observer = new MutationObserver(() => {
      const hasForm = Array.from(container.children).some(child => child.tagName !== 'SCRIPT');
      if (hasForm) setStatus('ready');
    });
    observer.observe(container, {
      childList: true,
      subtree: true
    });
    const script = document.createElement('script');
    script.async = true;
    script.src = LOADER_SRC;
    script.setAttribute('data-beehiiv-form', formId);
    script.onerror = () => setStatus('error');
    container.appendChild(script);
    const timeout = window.setTimeout(() => {
      setStatus(current => current === 'loading' ? 'error' : current);
    }, 12000);
    return () => {
      observer.disconnect();
      window.clearTimeout(timeout);
      container.innerHTML = '';
    };
  }, [formId]);
  return <div className={className} data-id="element-1" data-mp="1kthvz01okl4y">
      {status === 'loading' && <div role="status" aria-live="polite" className="flex h-14 w-full items-center gap-3 rounded-full bg-neutral-100 px-5 text-sm text-neutral-600" data-id="element-2" data-mp="1fvorqcjxu17b">
          <span className="h-4 w-4 animate-spin rounded-full border-2 border-neutral-300 border-t-wt-primary-color" data-id="element-3" data-mp="1653rkkom8oma" />
          Loading the signup form…
        </div>}
      {status === 'error' && <p role="alert" className="text-sm text-neutral-600" data-id="element-4" data-mp="x56y85ra71kw">
          The signup form didn't load. Please refresh the page, or check that
          your browser isn't blocking it.
        </p>}
      <div ref={containerRef} className="w-full" data-id="element-5" data-mp="ihgqe77eeg0h" />
    </div>;
}